import { ReactNode } from "react";

import { Typography } from "@/modules/theme/components/Typography/Typography";
import { useTheme } from "@/modules/theme/hooks/useTheme";

import { createEmptyListStyles } from "./helpers/createEmptyListStyles";

interface EmptyListProps {
  children: ReactNode;
  heading?: string;
}

export const EmptyList = ({ children, heading }: EmptyListProps) => {
  const classes = createEmptyListStyles(useTheme());
  return (
    <div className={classes.root}>
      {heading && (
        <Typography variant="heading" className={classes.heading}>
          {heading}
        </Typography>
      )}
      <div className={classes.contentWrapper}>{children}</div>
    </div>
  );
};
